(() => {
  const resourcesAlreadyLoaded = [];
  const resourcesLoadedFromCache = [];

  if (window.PerformanceObserver) {
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.transferSize > 0) {
          return;
        }

        resourcesLoadedFromCache.push(entry.name);
      });
    });

    observer.observe({ entryTypes: ['resource'] });
  }

  const loadLazyImage = (elem) => {
    const noScript = window.swinger.$('noscript', elem)[0];
    const lazyImage = window.swinger.$('img[loading="lazy"]', elem)[0];

    if (noScript) {
      const dom = document.createElement('div');

      dom.innerHTML = (noScript.textContent.trim() || noScript.innerHTML.trim());

      while (dom.children.length) {
        noScript.parentNode.insertBefore(dom.children[0], noScript);
      }

      noScript.parentNode.removeChild(noScript);
      return;
    }

    if (lazyImage) {
      lazyImage.setAttribute('loading', 'eager');
    }
  };
  const noscriptParentObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      window.swinger.eventHub.trigger(entry.target, 'swinger-image:load');
    });
  }, {
    rootMargin: '500px 200px 1000px 200px',
    scrollMargin: '0px 50px 0px 50px',
    threshold: 0.001,
  });

  document.addEventListener('swinger-image:load', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    loadLazyImage(elem);
    noscriptParentObserver.unobserve(elem);
  });

  window.swinger.observer.initialize('.swinger-image__lazy-load', (elem) => {
    const parent = elem.closest('.swinger-image');

    noscriptParentObserver.observe(parent);
  }, false);

  document.addEventListener('load', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const imageUrl = elem.currentSrc;

    if (!elem.matches('.swinger-image__image[decoding="async"]')) {
      return;
    }

    elem.classList.add('swinger-image__image--has-loaded');

    if (resourcesAlreadyLoaded.indexOf(imageUrl) === -1) {
      resourcesAlreadyLoaded.push(imageUrl);
      elem.classList.add('swinger-image__image--fade-in');
    }

    if (resourcesLoadedFromCache.indexOf(imageUrl) > -1) {
      elem.classList.add('swinger-image__image--has-loaded-from-cache');
    }
  }, true);
})();
